// Utilidades para manejo de colores en la aplicación
// Mapeo de colores hex a nombres de clase CSS

export const COLOR_MAP = {
  '#F37F31': 'orange',
  '#009A88': 'teal',
  '#E74C3C': 'red',
  '#3498DB': 'blue',
  '#9B59B6': 'purple',
  '#F39C12': 'orange',
  '#2ECC71': 'green',
  '#1ABC9C': 'teal',
  '#34495E': 'dark',
  '#E67E22': 'orange',
  '#8E44AD': 'purple',
  '#16A085': 'teal',
  '#D35400': 'orange',
  '#2980B9': 'blue',
  '#27AE60': 'green',
  '#C0392B': 'red',
  '#7F8C8D': 'gray',
  '#F1C40F': 'yellow',
  '#E91E63': 'pink',
  '#3F51B5': 'indigo',
  '#FF5722': 'orange',
  '#00BCD4': 'cyan',
  '#4CAF50': 'green',
  '#FF9800': 'orange',
  '#795548': 'brown',
  '#607D8B': 'gray',
  '#9C27B0': 'purple',
  '#00ACC1': 'cyan',
  '#8BC34A': 'lime',
  '#FFC107': 'yellow'
};

/**
 * Convierte un color hex a su nombre de clase CSS correspondiente
 * @param {string} hexColor - Color en formato hex (ej: '#F37F31')
 * @param {string} defaultColor - Color por defecto si no se encuentra el mapeo
 * @returns {string} - Nombre de la clase CSS
 */
export function getColorClassName(hexColor, defaultColor = 'teal') {
  return COLOR_MAP[hexColor] || defaultColor;
}

/**
 * Obtiene el nombre de clase CSS para un curso basado en su índice
 * @param {number} index - Índice del curso
 * @param {string} courseId - ID del curso (opcional, para consistencia)
 * @param {string} subjectName - Nombre de la materia (opcional, para consistencia)
 * @param {Function} getRandomColor - Función para obtener color aleatorio
 * @returns {string} - Nombre de la clase CSS
 */
export function getCourseColorClassName(index, courseId = null, subjectName = '', getRandomColor = null) {
  if (!getRandomColor) {
    return 'teal'; // Color por defecto si no hay función de color
  }
  
  // Usar courseId y subjectName si están disponibles, sino usar índice
  const colorKey = courseId && subjectName ? `${courseId}-${subjectName}` : `course-${index}`;
  const hexColor = getRandomColor(colorKey);
  
  return getColorClassName(hexColor);
}
